import axios from "axios";
import { decryptionData } from '@/components/utils/utils.js';
import Notification from  '@/components/Notification';
import { mapGetters } from 'vuex';

export default {
  components: {
    Notification: Notification
  },
  data () {
    return {
      mode: 'account',
      typeOptions: [
        { text: 'Account', value: 'account' },
        { text: 'Organization', value: 'organization' },
      ],
      tableLoading : false,
      type_delete:"",
      deleteType: 'account',
      action_btn:"",
      isCommaError: [],
      datatable: [],
      datatable_new: [],
      dialogDelete: false,
      search:'',
      collect_news_val: true,
      collect_twit_val: true,
      collect_ig_val: true,
      collect_tiktok_val: true,
      collect_ytb_val: true,
      collect_fb_val: true,

      dialogPinnsed:false,
      dialogAddPinned: false,
      dialogGroup: false,
      activeGroup: '',
      activeGroupType: '',
      pinned_id: '',
      organization_id: '',
      person_id: '',
      name_action_dialog: '',
      item_account_news: [
        {account : '',id_account : '',collection: ''}
      ],
      item_account_twet: [
        {account : '',id_account : '',collection: ''}
      ],
      item_account_ig: [
        {account : '',id_account : '',collection: ''}
      ],
      item_account_tiktok: [
        {account : '',id_account : '',collection: ''}
      ],
      item_account_youtube: [
        {account : '',id_account : '',collection: ''}
      ],
      item_account_facebook: [
        {account : '',id_account : '',collection: ''}
      ],

      btnload:false,
      alertSuccess:'',
      alertFailed:'',
      alert_err_attention: "",
      text_delete:"",
      isAdd: false,
      uniqueId: "",
      step: 1,
      account: "",
      addvalPinned: "",
      valueAddAccount:[],
      listAccount: [],
      listOrganization: [],
      accountSource: [],
      organizationSource: [],

      brandCategory_id: "",
      branchCategoryIdrules: [
        v => !!v || 'Branch Category is required',
      ],
      listBrand: [],

      analysis_id: "",
      analisisIdrules: [
        v => !!v || 'Group Analisis is required',
      ],
      listAnalysis: [],

      resultAccountWithId: [],
      selectedGroupAnalysis: null,
      indexDelete: [],
      deleted_detail_account: [],
      chip1: true,
      chip2: true,
      chip3: true,
      chip4: true,
    }
  },
  computed: {
    page() {
      return this.$store.state.breadcrumbs
    },
    ...mapGetters(['navbarWithName']),
    isOrg() {
      return this.mode === 'organization'
    },
    dialogTitle() {
      return this.isOrg ? 'Pinned Organization' : 'Pinned Account'
    },
    cfg() {
      return this.cfgFor(this.mode)
    },
    resultAccount() {
      return this.isOrg ? this.organizationSource : this.accountSource
    },
    selectItems() {
      return this.isOrg ? this.listOrganization : this.listAccount
    },
    selectItemText() {
      return this.cfg.selectItemText
    },
    selectItemValue() {
      return this.cfg.selectItemValue
    },
    selectLabel() {
      return this.cfg.selectLabel
    },
    pinnedAccount() {
      return this.resultAccountWithId.filter(i => i.TYPE === 'account')
    },
    pinnedOrganization() {
      return this.resultAccountWithId.filter(i => i.TYPE === 'organization')
    },
    groupedAccount() {
      return this.groupList(this.pinnedAccount)
    },
    groupedOrganization() {
      return this.groupList(this.pinnedOrganization)
    },
    filteredDatatable() {
      if (!this.datatable_new.length) return this.datatable_new;
      var hasGroupField = 'GROUP_ANALYSIS' in this.datatable_new[0];
      if (!hasGroupField || !this.selectedGroupAnalysis) return this.datatable_new;
      return this.datatable_new.filter(item => {
        let group = item.GROUP_ANALYSIS || 'Tanpa Group';
        return group === this.selectedGroupAnalysis;
      });
    },
    activeGroupItems() {
      if (!this.activeGroup) return [];
      return this.resultAccountWithId.filter(item => {
        return (item.GROUP_ANALYSIS || 'Tanpa Group') === this.activeGroup
          && item.TYPE === this.activeGroupType;
      });
    },
    dynamicHeaders() {
      const baseHeaders = [
        { text: 'Type', value: 'TYPE' },
        { text: 'User Display Name', value: 'USER_DISPLAY_NAME' },
        { text: 'News', value: 'NEWS' },
        { text: 'Twitter', value: 'TWEET' },
        { text: 'Instagram', value: 'INSTAGRAM' },
        { text: 'Tik Tok', value: 'TIKTOK' },
        { text: 'Youtube', value: 'YOUTUBE' },
        { text: 'Facebook', value: 'FACEBOOK' },
      ];

      let filteredHeaders = baseHeaders;

      if (this.collect_news_val == false) {
        filteredHeaders = filteredHeaders.filter(header => header.value !== 'NEWS');
      }
      if (this.collect_twit_val == false) {
        filteredHeaders = filteredHeaders.filter(header => header.value !== 'TWEET');
      }
      if (this.collect_ig_val == false) {
        filteredHeaders = filteredHeaders.filter(header => header.value !== 'INSTAGRAM');
      }
      if (this.collect_tiktok_val == false) {
        filteredHeaders = filteredHeaders.filter(header => header.value !== 'TIKTOK');
      }
      if (this.collect_ytb_val == false) {
        filteredHeaders = filteredHeaders.filter(header => header.value !== 'YOUTUBE');
      }
      if (this.collect_fb_val == false) {
        filteredHeaders = filteredHeaders.filter(header => header.value !== 'FACEBOOK');
      }
      return filteredHeaders;
    },
    analisysDisplayName() {
      if (this.analysis_id && typeof this.analysis_id === 'object') {
        return this.analysis_id.name || '';
      }
      const found = this.listAnalysis.find(a => a.valueanalysis == this.analysis_id);
      return found ? found.name : (this.analysis_id ? this.analysis_id : '');
    },
    brandCategoryDisplayName() {
      if (this.brandCategory_id && typeof this.brandCategory_id === 'object') {
        return this.brandCategory_id.name || '';
      }
      const found = this.listBrand.find(b => b.valueBrand == this.brandCategory_id);
      return found ? found.name : (this.brandCategory_id ? this.brandCategory_id : '');
    }
  },
  mounted(){
    this.loadAll()
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
    mode() {
      this.account = ''
    }
  },
  methods:{
    cfgFor(type) {
      if (type === 'organization') {
        return {
          nextStepUrl: 'pinned-entity-id',
          editUrl: '/pinned-entity-id',
          actionUrl: '/pinned-entity/action',
          deleteDetailUrl: '/pinned-entity/detail',
          deletePinUrl: '/pinned-entity/pinned',
          idField: 'organization_id',
          selectItemText: 'name_organization',
          selectItemValue: 'valueorganization',
          displayKey: 'ORG_DISPLAY_NAME',
          selectLabel: 'Organization',
        }
      }
      return {
        nextStepUrl: '/pinned-account-id',
        editUrl: '/pinned-account-id',
        actionUrl: '/pinned_account/action',
        deleteDetailUrl: '/pinned-history/delete',
        deletePinUrl: '/pinned-account/delete',
        idField: 'person_id',
        selectItemText: 'name',
        selectItemValue: 'valueperson',
        displayKey: 'USER_DISPLAY_NAME',
        selectLabel: 'Person',
      }
    },
    resetState() {
      this.account = ""
      this.listAccount = []
      this.listOrganization = []
      this.accountSource = []
      this.organizationSource = []
      this.resultAccountWithId = []
      this.selectedGroupAnalysis = null
      this.datatable = []
      this.datatable_new = []
      this.listAnalysis = []
      this.listBrand = []
    },
    groupList(list) {
      let grouped = {};
      list.forEach(item => {
        let groupKey = item.GROUP_ANALYSIS || 'Tanpa Group';
        if (!grouped[groupKey]) {
          grouped[groupKey] = { GROUP_ANALYSIS: groupKey, items: [], count: 0 };
        }
        grouped[groupKey].items.push(item);
        grouped[groupKey].count++;
      });
      return Object.values(grouped);
    },
    blockComma(event, index,source) {
      if (event.keyCode === 188) {
        event.preventDefault();
        this.$set(this.isCommaError, index, { ...this.isCommaError[index], [source]: true });
        setTimeout(() => {
          this.$set(this.isCommaError, index, { ...this.isCommaError[index], [source]: false });
        }, 3000);
      }else{
        this.$set(this.isCommaError, index, { ...this.isCommaError[index], [source]: false });
      }
    },
    handlePaste(event, index,source) {
      const pastedText = event.clipboardData.getData('text');
      if (pastedText.includes(',')) {
        event.preventDefault();
        this.$set(this.isCommaError, index, { ...this.isCommaError[index], [source]: true });
        setTimeout(() => {
          this.$set(this.isCommaError, index, { ...this.isCommaError[index], [source]: false });
        }, 3000);
      }
    },
    openGroup(group, type) {
      this.activeGroup = group;
      this.activeGroupType = type;
      this.dialogGroup = true;
    },
    editChipItem(item) {
      var found = this.datatable.find(d => d.SEQ_ID === item.SEQ_ID);
      const type = (found && found.TYPE) || item.TYPE;
      if (found) {
        this.mode = type;
        if (type === 'organization') {
          this.getIdPinOrganization(found);
        } else {
          this.getIdPinAccount(found);
        }
      }
    },
    rowClass(item) {
      if (item.STATUS_ACTIVE === 1) {
        return 'row-inactive';
      }
      return '';
    },
    customAnalysisFilter(item, queryText, itemText) {
      return (queryText || '').toLowerCase().indexOf(itemText.toLowerCase()) > -1;
    },
    loadAll(){
      this.resetState();
      const headers = { 'auth-token': localStorage.getItem('token_app') };
      Promise.all([
        axios.get('pinned_account', { headers }, { dataType: 'json' }),
        axios.get('pinned_entity', { headers }, { dataType: 'json' })
      ])
      .then(([accountRes, orgRes]) => {
        this.applyResponse(accountRes, 'account');
        this.applyResponse(orgRes, 'organization');

        let grouped = {};
        for (let gi = 0; gi < this.resultAccountWithId.length; gi++) {
          let gKey = this.resultAccountWithId[gi].GROUP_ANALYSIS || 'Tanpa Group';
          if (!grouped[gKey]) grouped[gKey] = 0;
          grouped[gKey]++;
        }
        let groupKeys = Object.keys(grouped);
        if (groupKeys.length === 1) {
          this.selectedGroupAnalysis = groupKeys[0];
        } else {
          this.selectedGroupAnalysis = null;
        }

        this.isAdd = false;
      })
      .catch((e) => {
        switch (e.response && e.response.status) {
          case 404:
            if (this.$refs.alert) this.$refs.alert.error_login(404);
            break;
          case 403:
            if (this.$refs.alert) this.$refs.alert.error_login(403);
            break;
          default:
            console.log('some other error');
            break;
        }
        console.log(e)
      });
    },
    applyResponse(response, type) {
      let res = decryptionData(response.data.token);
      let data_encript = res.data;

      const raw = (res.data_table || []).map(r => Object.assign({}, r, { TYPE: type }));
      this.datatable = this.datatable.concat(raw);

      const dtAll = (data_encript.data_table_all || []).map(r => Object.assign({}, r, { TYPE: type }));
      this.datatable_new = this.datatable_new.concat(dtAll);

      this.collect_news_val = res.collection_news;
      this.collect_twit_val = res.collection_twitter;
      this.collect_ig_val = res.collection_instagram;
      this.collect_tiktok_val = res.collection_tiktok;
      this.collect_ytb_val = res.collection_ytb;
      this.collect_fb_val = res.collection_facebook;

      const pinned = data_encript.pinned || [];
      for (let i = 0; i < pinned.length; i++) {
        const p = pinned[i];
        let colorpin = '';
        if (p.USER_TYPE === 1) colorpin = 'primary';
        if (p.USER_TYPE === 2) colorpin = 'error';

        const resultpin = {
          SEQ_ID: p.SEQ_ID,
          GROUP_ID: p.GROUP_ID,
          USER_ID: p.USER_ID,
          USER_DISPLAY_NAME: p.USER_DISPLAY_NAME,
          GROUP_ANALYSIS: p.GROUP_ANALYSIS,
          COLOR_BRAND: p.COLOR,
          COLOR: colorpin,
          TYPE: type,
        };
        if (type === 'organization') {
          resultpin.ORGANIZATION_ID = p.ORGANIZATION_ID;
        } else {
          resultpin.PERSON_ID = p.PERSON_ID;
        }
        this.resultAccountWithId.push(resultpin);
      }

      if (type === 'account') {
        const src = data_encript.peson_select || [];
        let arr = [];
        for (let i = 0; i < src.length; i++) {
          let t = '';
          if (src[i].USER_TYPE == 0) t = 'News';
          else if (src[i].USER_TYPE == 1) t = 'Twetter';
          else t = 'Youtube';
          arr.push({
            valueperson: src[i].SEQ_ID,
            name: src[i].USER_DISPLAY_NAME,
            subtitle: t
          });
        }
        this.listAccount = arr;
        this.accountSource = src;
      } else {
        const src = data_encript.organization_select || [];
        let arr = [];
        for (let i = 0; i < src.length; i++) {
          arr.push({
            valueorganization: src[i].SEQ_ID,
            name_organization: src[i].ORG_DISPLAY_NAME
          });
        }
        this.listOrganization = arr;
        this.organizationSource = src;
      }

      const analysis = data_encript.analysis_select || [];
      if (analysis.length > 0) {
        this.listAnalysis = analysis.map(a => ({ valueanalysis: a.SEQ_ID, name: a.GROUP_ANALYSIS }));
      }
      const category = data_encript.category_select || [];
      if (category.length > 0) {
        this.listBrand = category.map(c => ({ valueBrand: c.SEQ_ID, name: c.NAME_CATEGORY }));
      }
    },
    addResultAccount(){
      this.resultAccount.forEach((element) => {
        if(element["SEQ_ID"] == this.account){
          if (this.isOrg) {
            this.organization_id = element['SEQ_ID']
          } else {
            this.person_id = element['SEQ_ID']
          }
          this.name_action_dialog = element[this.cfg.displayKey]
          this.step = 1
          this.dialogAddPinned = true
        }
      })
    },
    valueAccount(account){
      const uuidv4 = require('uuid/v4');
      this.uniqueId = uuidv4()
      console.log(account);
    },
    setDetailAccount(detailAccount) {
      this.deleted_detail_account = [];

      this.item_account_news = [];
      const newsArray = detailAccount.news || [];
      if (newsArray.length > 0) {
        newsArray.forEach(data => {
          this.item_account_news.push({ account: data.name, id_account: data.seq_id, collection: this.collect_news_val });
        });
      } else {
        this.item_account_news.push({ account: '', id_account: '', collection: this.collect_news_val });
      }

      this.item_account_twet = [];
      const twitterArray = detailAccount.twitter || [];
      if (twitterArray.length > 0) {
        twitterArray.forEach(data => {
          this.item_account_twet.push({ account: data.name, id_account: data.seq_id, collection: this.collect_twit_val });
        });
      } else {
        this.item_account_twet.push({ account: '', id_account: '', collection: this.collect_twit_val });
      }

      this.item_account_ig = [];
      const igArray = detailAccount.ig || [];
      if (igArray.length > 0) {
        igArray.forEach(data => {
          this.item_account_ig.push({ account: data.name, id_account: data.seq_id, collection: this.collect_ig_val });
        });
      } else {
        this.item_account_ig.push({ account: '', id_account: '', collection: this.collect_ig_val });
      }

      this.item_account_tiktok = [];
      const tiktokArray = detailAccount.tiktok || [];
      if (tiktokArray.length > 0) {
        tiktokArray.forEach(data => {
          this.item_account_tiktok.push({ account: data.name, id_account: data.seq_id, collection: this.collect_tiktok_val });
        });
      } else {
        this.item_account_tiktok.push({ account: '', id_account: '', collection: this.collect_tiktok_val });
      }

      this.item_account_youtube = [];
      const youtubeArray = detailAccount.youtube || [];
      if (youtubeArray.length > 0) {
        youtubeArray.forEach(data => {
          this.item_account_youtube.push({ account: data.name, id_account: data.seq_id, collection: this.collect_ytb_val });
        });
      } else {
        this.item_account_youtube.push({ account: '', id_account: '', collection: this.collect_ytb_val });
      }

      this.item_account_facebook = [];
      const facebookArray = detailAccount.facebook || [];
      if (facebookArray.length > 0) {
        facebookArray.forEach(data => {
          this.item_account_facebook.push({ account: data.name, id_account: data.seq_id, collection: this.collect_fb_val });
        });
      } else {
        this.item_account_facebook.push({ account: '', id_account: '', collection: this.collect_fb_val });
      }
    },
    nextStep() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        let data = {
          seq_id: '',
          analysis_id: this.analysis_id,
          brandCategory_id: this.brandCategory_id
        };
        data[this.cfg.idField] = this.isOrg ? this.organization_id : this.person_id;
        axios({
          method: "put",
          url: this.cfg.nextStepUrl,
          data: data,
          headers: {
            'auth-token': localStorage.getItem('token_app')
          },
          dataType: 'json'
        })
        .then((response) => {
          let result = decryptionData(response.data.token);

          if (result.analysis_id) {
            this.analysis_id = result.analysis_id;
          }
          if (result.brand_category_id) {
            this.brandCategory_id = result.brand_category_id;
          }

          this.setDetailAccount(result.detail_account || {});

          this.pinned_id = result.seq_id_pinned || '';
          this.step = 2;
        })
        .catch(function (error) {
          console.log(error);
        });
      }
    },
    getIdPinOrganization (item) {
      this.action_btn = 'update';

      axios({
        method: "put",
        url: this.cfg.editUrl,
        data: {
          seq_id: item.SEQ_ID,
          organization_id: item.PERSON_ID
        },
        headers: {
          'auth-token': localStorage.getItem('token_app')
        },
        dataType: 'json'
      })
      .then((response) => {
        let result = decryptionData(response.data.token);
        this.applyEditResult(result, item, item.ORGANIZATION_ID);
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    getIdPinAccount (item) {
      this.action_btn = 'update';

      axios({
        method: "put",
        url: this.cfg.editUrl,
        data: {
          seq_id: item.SEQ_ID,
          person_id: item.PERSON_ID
        },
        headers: {
          'auth-token': localStorage.getItem('token_app')
        },
        dataType: 'json'
      })
      .then((response) => {
        let result = decryptionData(response.data.token);
        this.applyEditResult(result, item, item.PERSON_ID);
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    applyEditResult(result, item, entityId) {
      let selectedId = result.analysis_id;
      this.analysis_id = this.listAnalysis.find(a => a.valueanalysis === selectedId) || null;
      this.brandCategory_id = result.brand_category_id;

      this.setDetailAccount(result.detail_account || {});

      this.pinned_id = result.seq_id_pinned;
      if (item.TYPE === 'organization') {
        this.organization_id = entityId;
      } else {
        this.person_id = entityId;
      }
      this.name_action_dialog = item.USER_DISPLAY_NAME;
      this.step = 2;
      this.dialogAddPinned = true;
    },
    postAccount(){
      const isValid = this.$refs.form.validate();
      if (isValid) {
        const entityId = this.isOrg ? this.organization_id : this.person_id;
        if(entityId != "" || this.isAdd == true){
          let payload = {
            action : this.action_btn,
            brand_category_id : this.brandCategory_id,
            analysis_id : this.analysis_id,
            pinned_id : this.pinned_id,
            account_news : this.item_account_news,
            account_twet : this.item_account_twet,
            account_ig : this.item_account_ig,
            account_tiktok : this.item_account_tiktok,
            account_youtube : this.item_account_youtube,
            account_facebook : this.item_account_facebook,
            id_detail_account : this.deleted_detail_account.length ? this.deleted_detail_account.join(',') : '',
          };
          payload[this.cfg.idField] = entityId;
          axios.post(this.cfg.actionUrl,
            payload,
            { headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
          )
          .then((response) => {
            var status = response.data.status
            var messages = response.data.msg
            if(status == 200){
              this.loadAll();
              this.alertSuccess = true;
              this.alert_err_attention = messages;
              this.btnload = false
              this.close();
            }else{
              this.alertFailed = true;
              this.alert_err_attention = messages;
              this.btnload = false
            }
          })
          .catch((e) => {
            switch (e.response && e.response.status) {
              case 404:
                if (this.$refs.alert) this.$refs.alert.error_login(404);
                break;
              case 403:
                if (this.$refs.alert) this.$refs.alert.error_login(403);
                break;
              case 400:
                this.alertFailed = true;
                this.alert_err_attention = e.response.data.msg;
                this.btnload = false
                break;
              default:
                console.log('some other error');
                break;
            }
          });
        }else{
          this.alertFailed = true;
          this.alert_err_attention = "Account has not been added";
          this.btnload = false
        }
      }
    },
    closeChip(item,type){
      this.type_delete = type
      this.deleteType = item.TYPE || this.mode
      this.pinned_id = item.SEQ_ID
      this.dialogDelete = true
      this.text_delete = item.TYPE === 'organization' ? "pinned organization" : "pinned account"

      if(type != 'pin'){
        this.text_delete = "list detail pinned";
      }
    },
    deleteItemConfirm(){
      this.indexDelete.push(this.pinned_id)
      this.isAdd = true
      const delCfg = this.cfgFor(this.deleteType)
      let url = delCfg.deleteDetailUrl
      if(this.type_delete == 'pin'){
        url = delCfg.deletePinUrl
      }
      axios({
        method: "delete",
        url: url,
        data: {
          id_pinned: this.pinned_id
        },
        headers:{'auth-token':localStorage.getItem('token_app')},
        dataType: 'json'
      })
      .then((response) => {
        var status = response.data.status
        var messages = response.data.msg
        if(status == 200){
          this.loadAll()
          this.alertSuccess = true;
          this.alert_err_attention = messages;
        }else{
          this.alertFailed = true;
          this.alert_err_attention = messages;
        }
        this.dialogDelete = false
      })
      .catch(function (error) {
        this.dialogDelete = false
        this.alertFailed = true;
        this.alert_err_attention = 'Delete Failed '+error;
      })
      this.resultAccountWithId = this.resultAccountWithId.filter((obj) => obj.SEQ_ID !== this.pinned_id);
    },
    closeDelete () {
      this.dialogDelete = false
      this.pinned_id = ""
      this.action_btn = ""
    },
    trackDeletedId(item) {
      if (item && item.id_account) {
        if (this.deleted_detail_account.indexOf(item.id_account) === -1) {
          this.deleted_detail_account.push(item.id_account)
        }
      }
    },
    add_news() {
      this.item_account_news.push({ account: '' ,id_account: '', collection: '' })
    },
    remove_news(item, index) {
      if(index > 0){
        this.trackDeletedId(item)
        this.item_account_news.splice(index, 1)
      }else{
        this.alertFailed = true;
        this.alert_err_attention = "The First Line cannot be deleted";
      }
    },
    add_tweet() {
      this.item_account_twet.push({ account: '' ,id_account: '', collection: this.collect_twit_val })
    },
    remove_tweet(item, index) {
      if(index > 0){
        this.trackDeletedId(item)
        this.item_account_twet.splice(index, 1)
      }else{
        this.alertFailed = true;
        this.alert_err_attention = "The First Line cannot be deleted";
      }
    },
    add_ig() {
      this.item_account_ig.push({ account: '' ,id_account: '', collection: this.collect_ig_val })
    },
    remove_ig(item, index) {
      if(index > 0){
        this.trackDeletedId(item)
        this.item_account_ig.splice(index, 1)
      }else{
        this.alertFailed = true;
        this.alert_err_attention = "The First Line cannot be deleted";
      }
    },
    add_tiktok() {
      this.item_account_tiktok.push({ account: '' ,id_account: '', collection: this.collect_tiktok_val })
    },
    remove_tiktok(item, index) {
      if(index > 0){
        this.trackDeletedId(item)
        this.item_account_tiktok.splice(index, 1)
      }else{
        this.alertFailed = true;
        this.alert_err_attention = "The First Line cannot be deleted";
      }
    },
    add_youtube() {
      this.item_account_youtube.push({ account: '' ,id_account: '', collection: this.collect_ytb_val })
    },
    remove_youtube(item, index) {
      if(index > 0){
        this.trackDeletedId(item)
        this.item_account_youtube.splice(index, 1)
      }else{
        this.alertFailed = true;
        this.alert_err_attention = "The First Line cannot be deleted";
      }
    },
    add_facebook() {
      this.item_account_facebook.push({ account: '' ,id_account: '', collection: this.collect_fb_val })
    },
    remove_facebook(item, index) {
      if(index > 0){
        this.trackDeletedId(item)
        this.item_account_facebook.splice(index, 1)
      }else{
        this.alertFailed = true;
        this.alert_err_attention = "The First Line cannot be deleted";
      }
    },
    closeAdd () {
      this.close()
    },
    close () {
      if (this.isOrg) {
        this.organization_id = "";
      } else {
        this.person_id = "";
      }
      this.action_btn = ""
      this.pinned_id = ""
      this.selectedGroupAnalysis = null

      this.item_account_news =[];
      this.item_account_news.push({ account : '',id_account : '',collection: this.collect_news_val })

      this.item_account_twet =[];
      this.item_account_twet.push({ account : '',id_account : '',collection: this.collect_twit_val })

      this.item_account_ig =[];
      this.item_account_ig.push({ account : '',id_account : '',collection: this.collect_ig_val })

      this.item_account_tiktok =[];
      this.item_account_tiktok.push({ account : '',id_account : '',collection: this.collect_tiktok_val })

      this.item_account_youtube =[];
      this.item_account_youtube.push({ account : '',id_account : '',collection: this.collect_ytb_val })

      this.item_account_facebook =[];
      this.item_account_facebook.push({ account : '',id_account : '',collection: this.collect_fb_val })

      this.isAdd = false

      this.deleted_detail_account = []
      this.step = 1
      this.dialogPinnsed = false
      this.dialogAddPinned = false
    },
  }
}
